import React from 'react';
import './App.css';

function Input(props) {
	const ingredientsByRating = props.ingredients.reduce( (acc, current, index) => {
		let rating = current.rating.toLowerCase();

		if (!acc[rating]) {
			acc[rating] = [current];
		} else {
			acc[rating].push(current);
		}

		return acc;
	}, {});

	const orderDictionary = {
		'best': 'best',
		'good': 'good',
		'average': 'so-so',
		'poor': 'bad'
	};

	let order = Object.keys(orderDictionary).filter( (rating) => ingredientsByRating[rating]);

	const output = order.map( (rating, index) => {
		const displayRating = orderDictionary[rating];

		return (
			<div className="rating-wrapper" key={displayRating}>
				<li className='Output' key={displayRating}>
					<span className={'rating rating-' + displayRating}>{displayRating}</span>
					{ ingredientsByRating[rating].map((x) => { return ingredient(x.name) })}
				</li>
				<hr></hr>
			</div>
		)
	});

	function ingredient(name) {
		return <span className="ingredient" key={name}>{name}</span>
	}

	return (
		<React.Fragment>
			<div className="output-wrapper">
				<div className="results">Ingredient Breakdown</div>
				<hr></hr>
				<ul className="ul-output">{output}</ul>
			</div>
		</React.Fragment>
	);
}

export default Input;



// WEBPACK FOOTER //
// ./src/Output.jsx